module.exports = __webpack_public_path__ + "static/img/ydyl1.aa51fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ydyl1.jpg
// module id = /HKS
// module chunks = 0